/* eslint-disable i18next/no-literal-string */
import { cn } from "~/lib/utils";
import { colors } from "~/components/landing/colors";

/**
 * Ported from bouncieweb's `LandingPageComponents/MaintenanceExample.js`
 * (plus its `WrappedSVGs/MaintenanceIcon`).
 *
 * A mock push notification for a diagnostic trouble code: orange wrench/bolt
 * glyph, the code as a bold headline, the description, and a timestamp.
 *
 * Original breakpoint map (theme/mediaQueries): lg 1024px -> lg:  xlg 1280px -> xl:
 */

function MaintenanceIcon({
  height = 17,
  width = 21,
  color = colors.orange,
}: {
  height?: number;
  width?: number;
  color?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.4045 0.843735V1.90328H8.11972V2.69794H8.03579H4.65084C4.28397 2.69794 3.98804 3.10861 3.98804 3.61551V4.69983H2.41411C1.96244 4.69983 1.59556 5.25057 1.59556 5.92803V7.12764H0.961318V4.13766H0V13.7889H0.962184V10.7998H1.59556V12.8198C1.59556 13.4973 1.96244 14.0471 2.41411 14.0471H4.15331L6.22824 16.2557V16.2719H6.24208L6.25765 16.2891L6.2715 16.2719H9.46003H12.8649H16.1079C16.4592 16.2719 16.743 15.8603 16.743 15.3534V13.8003H17.8428V14.9294C17.8428 15.4363 18.2175 15.8479 18.6769 15.8479H19.6642C20.1254 15.8479 20.4983 15.4363 20.4983 14.9294V4.53309C20.4983 4.02618 20.1254 3.61551 19.6642 3.61551H18.6769C18.2175 3.61551 17.8437 4.02618 17.8437 4.53309V5.16862H17.3669L14.9606 2.71223V2.69794H14.945L14.9286 2.67983L14.9147 2.69794H11.5869H11.4545V1.90328H14.1688V0.843735H5.4045ZM9.31903 6.24988H10.7126L9.46116 8.80303H12.017L9.20717 13.2003L10.2559 10.1165H7.42254L9.31903 6.24988Z"
        fill={color}
      />
    </svg>
  );
}

export default function MaintenanceExample({
  className,
}: {
  className?: string;
}) {
  return (
    // Notification
    <div
      className={cn(
        "mx-auto flex max-w-[300px] flex-row items-center justify-start gap-3",
        "rounded-[8px] px-3 py-2 shadow-[0_5px_10px_rgba(0,0,0,0.1)]",
        className,
      )}
      style={{ background: "rgba(255, 255, 255, 0.7)" }}
    >
      <div className="w-[22px]">
        <MaintenanceIcon />
      </div>
      {/* Status */}
      <div className="text-left text-[14px] lg:text-[12px] xl:text-[14px]">
        {/* Header */}
        <div className="inline-block font-bold">P0300</div>
        {/* PrimaryText */}
        <div className="text-[12px] lg:text-[10px] xl:text-[12px]">
          Random Cylinder Misfire Detected
        </div>
        {/* SecondaryText */}
        <div
          className="text-[12px] [text-wrap:nowrap]"
          style={{ color: colors.grayDark1 }}
        >
          Today at 10:14 PM
        </div>
      </div>
    </div>
  );
}
